export default "__VITE_ASSET__C9BFBDW1__"